import { APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  ApiConfiguration,
  BaseService,
  ConfigurationService,
  MATERIAL_FLAG,
  MenuItem,
  NoMenuItem,
  WITH_CREDENTIALS_FLAG,
} from '@DataFriends-Group/ngx-core';
import { environment } from 'src/environments/environment';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

function initializeApp(base: BaseService, config: ConfigurationService) {
  return () => {
    config.backend = new ApiConfiguration(
      environment.api.port ?? location.port,
      environment.api.hostname ?? location.hostname,
      environment.api.protocol ?? location.protocol,
    );

    console.log('BE address set to', config.backend);
    base.menu = [
      new NoMenuItem('app.router.access-denied', 'not-authorized'),
      new NoMenuItem('app.router.page-not-found', 'not-found'),
      new NoMenuItem('app.router.settings-page', 'settings'),
      new MenuItem('app.router.dealers', 'store', 'dealers'),
    ];
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      multi: true,
      deps: [BaseService, ConfigurationService],
    },
    {
      provide: MATERIAL_FLAG,
      useValue: true,
    },
    {
      provide: WITH_CREDENTIALS_FLAG,
      useValue: false,
    },
  ],
};
